import { render, staticRenderFns } from "./Cyberboard.vue?vue&type=template&id=576f25e0"
import script from "./Cyberboard.vue?vue&type=script&lang=ts"
export * from "./Cyberboard.vue?vue&type=script&lang=ts"
import style0 from "./Cyberboard.vue?vue&type=style&index=0&id=576f25e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports